import React, {useCallback} from "react";
import {AdobeTrackActionActions, TutorialSteps} from "modules/enums";
import {ModalButtons, OutlinedButton, PrimaryButton} from "components/Common";
import {useTranslation} from "react-i18next";
import {AdobeAnalyticService} from "modules/utils/Services/AdobeAnalyticService";

interface IProps {
	activeStep: TutorialSteps;
	setActiveStep: (step: TutorialSteps) => void;
	closeClick: () => void;
}

export const TutorialActions: React.FC<IProps> = ({activeStep, setActiveStep, closeClick}) => {
	const {t} = useTranslation();
	const dispatchStep = useCallback(
		(step: TutorialSteps) => {
			if (setActiveStep && step !== activeStep) {
				setActiveStep(step);
			}
		},
		[setActiveStep, activeStep]
	);

	const handleClose = useCallback(() => {
		AdobeAnalyticService.TrackAction({
			"action.name": AdobeTrackActionActions.WelcomeModalAction.replace("--X--", "play"),
			"action.element.text": "play",
			"action.element.targetUrl": window.location.href,
			"action.element.index": 0,
		});
		if (closeClick) {
			closeClick();
		}
	}, [closeClick]);

	const startTutorial = useCallback(() => {
		dispatchStep(TutorialSteps.First);
		AdobeAnalyticService.TrackAction({
			"action.name": AdobeTrackActionActions.WelcomeModalAction.replace(
				"--X--",
				"how to play"
			),
			"action.element.text": "how to play",
			"action.element.targetUrl": window.location.href,
			"action.element.index": 1,
		});
	}, [dispatchStep]);

	const playNowHandler = useCallback(() => {
		AdobeAnalyticService.TrackAction({
			"action.name": AdobeTrackActionActions.HowToPlayStart,
			"action.element.text": "Play now",
			"action.element.targetUrl": window.location.href,
			"action.element.index": 0,
		});
		if (closeClick) {
			closeClick();
		}
	}, [closeClick]);

	if (activeStep === TutorialSteps.Introduce) {
		return (
			<ModalButtons className="half">
				<PrimaryButton onClick={handleClose}>{t("modal.tutorial.play")}</PrimaryButton>
				<OutlinedButton onClick={startTutorial}>
					{t("modal.tutorial.tutorial")}
				</OutlinedButton>
			</ModalButtons>
		);
	}

	return (
		<ModalButtons>
			<PrimaryButton onClick={playNowHandler}>{t("modal.tutorial.play_now")}</PrimaryButton>
		</ModalButtons>
	);
};
